import { Button } from '@seen/ui'
import { IconEdit, IconTrash, IconX } from '@tabler/icons-react'
import type { JSX, ReactNode } from 'react'

type HoverButtonTypes = 'edit' | 'delete' | 'cancel'

interface HoverButtonProps {
  type?: HoverButtonTypes
  icon?: ReactNode
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const HoverButtonIcons: Record<HoverButtonTypes, ReactNode> = {
  edit: <IconEdit size={16} />,
  delete: <IconTrash size={16} />,
  cancel: <IconX size={16} />,
}

export function HoverButton({
  type = 'edit',
  icon,
  onClick,
}: HoverButtonProps): JSX.Element {
  const defaultIcon = HoverButtonIcons[type]

  return (
    <Button
      variant="outline"
      className="opacity-0 transition-opacity group-hover:opacity-100"
      onClick={onClick}
      size="2xs"
    >
      {icon ?? defaultIcon}
    </Button>
  )
}
